import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { BackButton, Button, Title, ScannerCode, SelectResource, SelectPrintType, } from '../../../components/UI/ComponentsUI';
import ChangeLocationService from '../../../services/ChangeLocationService';
import { ENUMS, VISIONS } from '../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../utils/handleChangeHooks";
import { convertToUppercase, isNullOrEmpty, showMessageToastCustom, translate } from '../../../utils/util';
import InputUI from '../../../components/UI/InputUI';
import { getVision } from '../../../services/auth';

const MasterCim = (props) => {

    const [cimList, setCimList] = useState([]);
    const [masterCim, setMasterCim] = useState({
        location: '%',
        print: 'C',
        resourceId: props.user.resource || '',
        cims: [],
        cim: '',
        mdr: ''
    });

    const setResource = () => {
        if (masterCim.print === ENUMS.ePrintTypes.Click.value && !isNullOrEmpty(props.user?.resourceObj?.clickResourceName)) {
            return props.user?.resourceObj?.clickResourceName;
        }

        return props.user?.resourceObj?.name;
    }

    const onChange = (event) => {
        onValueChange(event, masterCim, setMasterCim);
    };

    const scanner = (value) => {
        addItem(value)
    };

    const addItem = (cim) => {
        if (!isNullOrEmpty(cim)) {
            let list = [];
            Object.assign(list, cimList);

            if (list.some((element) => element === cim)) {
                document.getElementById('cim').focus();
                return showMessageToastCustom(translate('warning', 'general'), "CIM já inserido!", 3000, 'mdi mdi-alert-circle-outline red-text');
            }

            list.push(cim);
            setCimList(list);
            document.getElementById('cim').value = '';
            document.getElementById('cim').focus();
            masterCim.cim = '';
            setMasterCim(masterCim);
        }
    };


    const removeItem = (item) => {
        let list = [];
        Object.assign(list, cimList);
        const findIndex = list.indexOf(item);
        list.splice(findIndex, 1);
        setCimList(list);
        document.getElementById('cim').focus();
    }

    const onChangeCim = (value) => {
        let newMasterCim = { ...masterCim };
        let cimValue = value?.trim().replace(/\s+/g, '');
        newMasterCim.cim = cimValue;
        document.getElementById('cim').value = cimValue;
        setMasterCim(newMasterCim);
    };

    const onSubmit = () => {
        if (validateInputsRequired("mastercim")) {

            if (cimList.length === 1) {
                return showMessageToastCustom(translate('warning', 'general'), "Master Cim deve conter mais de um CIM adicionado.", 3000, 'mdi mdi-alert-circle-outline red-text');
            }

            let model = { ...masterCim }
            model.resource = setResource() || '';
            model.printer = props.user.printer || '';
            model.cims = cimList;
            props.confirm(model, () => {
                props.history.go(-1);
            })
        }
    }

    const convertToUpper = (evt) => {
        convertToUppercase(evt)
        onChange(evt);
    }


    return (
        <div>
            <BackButton {...props} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-layers-triple-outline" label={"Gerar Master CIM"} />
                </div>
            </div>
            <div>
                <div className="container-fluid h-65 mt-25" />
                <div className="container s12" style={{ marginTop: '20px' }}>
                    <div className="card" id="mastercim">
                        <div className="card-content" style={{ padding: '10px' }}>
                            <div id="formInput" className="form-group">
                                <div className='row'>
                                    <div className="input-field col s6 no-padding m5">
                                        <SelectPrintType
                                            required
                                            onChange={onChange}
                                            value={masterCim?.print || ""}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s5">
                                        <SelectResource
                                            name="resourceId"
                                            id="resourceId"
                                            loadConfigLaser={getVision() === VISIONS.Jeep}
                                            required={masterCim.print === ENUMS.ePrintTypes.Logistics.value || masterCim.print === ENUMS.ePrintTypes.Click.value}
                                            value={masterCim?.resourceId}
                                            onChange={onChange} />
                                    </div>

                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s7">
                                        <InputUI
                                            label={translate('location', 'change-location')}
                                            id="location"
                                            name="location"
                                            type="text"
                                            defaultValue={masterCim.location || ''}
                                            onChange={onChange}
                                        />
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <InputUI
                                            required
                                            label="MDR"
                                            id="mdr"
                                            name="mdr"
                                            type="text"
                                            onChange={(e) => {
                                                e.target.value = e.target.value.replace(/\s/g, '');
                                                convertToUpper(e)
                                            }}
                                            value={masterCim.mdr}
                                        />
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="input-field no-padding col s10" style={{ marginTop: '10px' }}>
                                        <ScannerCode onScanner={scanner} />
                                        <InputUI
                                            label={translate('expedition:picking.cim')}
                                            id="cim"
                                            name="cim"
                                            type="text"
                                            value={masterCim.cim || ''}
                                            onChange={(event) => onChangeCim(event.target.value)}
                                        />
                                    </div>
                                    <div className="col s1" style={{ paddingTop: '10px' }}>
                                        <button
                                            className="btn-floating btn-Small btn-principal waves-effect waves-light"
                                            type="button"
                                            onClick={() => addItem(masterCim.cim)}
                                        >
                                            <i className={`mdi mdi mdi-plus`} />
                                        </button>
                                    </div>
                                </div>
                                {cimList.length > 0 &&
                                    <div>
                                        <div>
                                            {cimList.map((item, index) => {
                                                return (
                                                    <div className="col s12" key={index}>
                                                        <i className="mdi mdi-close sixth-text-color" style={{ cursor: 'pointer' }} onClick={() => removeItem(item)} />
                                                        <label className="list sixth-text-color">{item}</label>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                {cimList.length > 0 &&
                    <div className="row">
                        <div className="col s12">
                            <Button
                                full="true"
                                className="col s6 btn-principal"
                                text={"Gerar MasterCim"}
                                onClick={onSubmit}
                            />
                        </div>
                    </div>
                }
            </div>
        </div>
    );


}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer.user,
        resources: state.logisticsResourceReducer.list,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        confirm: (model, callback, callbackError) => {
            dispatch(ChangeLocationService.confirmMasterCim(model, callback, callbackError));
        }
    };
};


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(MasterCim)));